import { useEffect, useState } from 'react'

import RampCurvesPanel from '@/features/resource/components/rampCurves/RampCurvesPanel'
import ResourceCard from '@/features/resource/components/ResourceCard'
import { useResourceData } from '@/features/resource/contexts/ResourceDataContext'
import { useRampCurvesQuery } from '@/features/resource/hooks/useRampCurvesQuery'
import type { RampCurve } from '@/features/resource/types'

const ResourceRampCurvesCard = () => {
  const { resource } = useResourceData()
  const [localRampCurves, setLocalRampCurves] = useState<RampCurve[]>([])

  const { data: rampCurvesData } = useRampCurvesQuery(resource?.resourceID || '')

  useEffect(() => {
    if (rampCurvesData) {
      setLocalRampCurves(rampCurvesData.rampCurves)
    }
  }, [rampCurvesData])

  if (!resource) {
    return null
  }

  return (
    <ResourceCard
      content={
        <RampCurvesPanel rampCurves={localRampCurves} resource={resource} onRampCurvesChange={setLocalRampCurves} />
      }
    />
  )
}

export default ResourceRampCurvesCard
